import React, { useEffect, useState } from 'react';
import { MdDarkMode, MdLightMode } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { MdChevronRight, MdPerson, MdNotifications, MdLock, MdLanguage } from 'react-icons/md';

const Settings = () => {
  const [isDark, setIsDark] = useState(false);

  // hydrate from html class / localStorage
  useEffect(() => {
    const html = document.documentElement;
    const hasDark = html.classList.contains('dark');
    setIsDark(hasDark);
  }, []);

  const applyTheme = (dark) => {
    const html = document.documentElement;
    if (dark) html.classList.add('dark'); else html.classList.remove('dark');
    setIsDark(dark);
    try { localStorage.setItem('theme', dark ? 'dark' : 'light'); } catch {}
  };

  return (
    <div className="bg-background-light dark:bg-background-dark text-[rgb(65,74,76)] dark:text-[rgb(245,254,253)] min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold mb-2">Ayarlar</h2>
          <p className="text-base text-gray-500 dark:text-gray-400 mb-8">Hesap ve görünüm tercihlerini buradan yönetebilirsin.</p>

          <div className="space-y-6">
            {/* Görünüm */}
            <div className="bg-white dark:bg-[rgb(65,74,76)] p-6 rounded-lg shadow-md border border-gray-200 dark:border-gray-600">
              <h3 className="text-xl font-semibold mb-4">Görünüm</h3>
              <ul className="space-y-4">
                <li className="flex items-center justify-between py-2 border-b border-gray-200 dark:border-gray-600">
                  <div className="flex items-center gap-4">
                    <MdDarkMode className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                    <span>Karanlık Mod</span>
                  </div>
                  <label className="inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only" checked={isDark} onChange={(e)=>applyTheme(e.target.checked)} />
                    <span className="w-10 h-6 bg-gray-300 rounded-full relative transition-colors">
                      <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${isDark ? 'translate-x-4' : ''}`}></span>
                    </span>
                  </label>
                </li>
                <li className="flex items-center justify-between py-2">
                  <div className="flex items-center gap-4">
                    <MdLightMode className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                    <span>Aydınlık Mod</span>
                  </div>
                  <label className="inline-flex items-center cursor-pointer">
                    <input type="checkbox" className="sr-only" checked={!isDark} onChange={(e)=>applyTheme(!isDark)} />
                    <span className="w-10 h-6 bg-gray-300 rounded-full relative transition-colors">
                      <span className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${!isDark ? 'translate-x-4' : ''}`}></span>
                    </span>
                  </label>
                </li>
              </ul>
            </div>

            {/* Hesap (bağlantılı alt sayfalar) */}
            <div className="bg-white dark:bg-[rgb(65,74,76)] p-6 rounded-lg shadow-md border border-gray-200 dark:border-gray-600">
              <h3 className="text-xl font-semibold mb-4">Hesap</h3>
              <ul className="divide-y divide-gray-200 dark:divide-gray-600">
                <li className="py-3">
                  <Link to="/settings/profile" className="flex items-center justify-between group">
                    <span className="flex items-center gap-3">
                      <MdPerson className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                      <span>Profil Yönetimi</span>
                    </span>
                    <MdChevronRight className="text-gray-500 group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </li>
                <li className="py-3">
                  <Link to="/settings/notifications" className="flex items-center justify-between group">
                    <span className="flex items-center gap-3">
                      <MdNotifications className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                      <span>Bildirim Tercihleri</span>
                    </span>
                    <MdChevronRight className="text-gray-500 group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </li>
                <li className="py-3">
                  <Link to="/settings/privacy" className="flex items-center justify-between group">
                    <span className="flex items-center gap-3">
                      <MdLock className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                      <span>Gizlilik Ayarları</span>
                    </span>
                    <MdChevronRight className="text-gray-500 group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </li>
                <li className="py-3">
                  <Link to="/settings/language" className="flex items-center justify-between group">
                    <span className="flex items-center gap-3">
                      <MdLanguage className="text-[rgb(0,191,255)] text-xl" aria-hidden="true" />
                      <span>Dil Tercihi</span>
                    </span>
                    <MdChevronRight className="text-gray-500 group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </main>
    </div>
  );
};

export default Settings;
